import { z } from 'zod';

export enum AgentTypeEnum {
  Default = 1,
  CSVAgent = 2,
  Orchestration = 3
};
export const agentTypeSchema = z.nativeEnum(AgentTypeEnum);
export type AgentType = z.infer<typeof agentTypeSchema>;

export const getAgentTypeName = (typeId: AgentTypeEnum) => {
  return {
    [AgentTypeEnum.Default]: 'Default',
    [AgentTypeEnum.CSVAgent]: 'CSV Agent',
    [AgentTypeEnum.Orchestration]: 'Orchestration',
  }[typeId] ?? 'Unknown';
};

export enum AgentProtocolEnum {
  HTTP = 1,
  MCP = 2,
  A2A = 3,
  Internal = 4,
}
export const agentProtocolSchema = z.nativeEnum(AgentProtocolEnum);
export type AgentProtocol = z.infer<typeof agentProtocolSchema>;

export const getAgentProtocolName = (protocolId: AgentProtocolEnum) => {
  return {
    [AgentProtocolEnum.HTTP]: 'HTTP',
    [AgentProtocolEnum.MCP]: 'MCP',
    [AgentProtocolEnum.A2A]: 'A2A',
    [AgentProtocolEnum.Internal]: 'Internal',
  }[protocolId] ?? 'Unknown';
};

export enum AgentIdentifier {
  BrandInsights = 'bi-agent',
}